.divider {
  height: 0;
  border-bottom: 1px solid var(--color-divider);
}
